const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function getAllEspecialistas() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/especialistas`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAllEspecialistasAndAdmins() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/users?roles=author,administrator&orderby=id&order=desc&per_page=99`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAllEspecialistasInTreatAndPsicoHospAndAdmins(tratamientoId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/interdest?tratamiento=${tratamientoId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

// export async function getAllEspecialistasByEspecialidad() {
//   const authToken = sessionStorage.getItem( 'token' );
//   try {
//     const response = await fetch(`${API_URL}/users?roles=author&orderby=id&order=desc&per_page=99`, {
//       method: 'GET',
//       headers: {
//       'Accept': 'application/json',
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${ authToken }`,
//       },
//     } );
//     const data = await response.json();

    // return data;
//   } catch (error) {
//     console.error(error);
//   }
// }

export async function getEspecialistaByID(especialistaId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/users/${especialistaId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getSearchEspecialistas(especialistaQuery) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/users?roles=author&orderby=id&order=desc&per_page=50&search=${especialistaQuery}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getSearchEspecialistasAndAdmins(especialistaQuery) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/especialistas?&search=${especialistaQuery}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getEspecialistasByIds(especialistasIds) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/users?orderby=id&order=desc&per_page=50&include=${especialistasIds}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}